import { render, staticRenderFns } from "./wheel.vue?vue&type=template&id=133e2e12"
import script from "./wheel.vue?vue&type=script&lang=js"
export * from "./wheel.vue?vue&type=script&lang=js"
import style0 from "./wheel.vue?vue&type=style&index=0&id=133e2e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports